var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isLoading
    ? _c(
        "div",
        { staticClass: "content" },
        [
          _vm.isCompleted
            ? _c("req-money-complete", {
                attrs: { isSuccess: _vm.isSuccess },
                on: { refreshScreen: _vm.refreshScreen }
              })
            : _c("req-money-setting", {
                attrs: {
                  hasSetting: _vm.hasSetting,
                  isPaypal: _vm.isPaypal,
                  data: _vm.paymentInfo
                },
                on: { completed: _vm.requestCompleted }
              })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4301c816", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4301c816","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/revenue/ReqMoney.vue
// module id = null
// module chunks = 